/**
 * PaginationBar — controles compactos de paginação.
 * Esconde-se automaticamente se totalPages <= 1.
 */
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function PaginationBar({ page, totalPages, total, onChange, label = "resultado", testid = "pagination" }) {
  if (totalPages <= 1) {
    return total > 0 ? (
      <div className="text-xs text-muted-foreground" data-testid={`${testid}-summary`}>
        {total} {label}{total === 1 ? "" : "s"}
      </div>
    ) : null;
  }
  const goto = (p) => onChange(Math.max(1, Math.min(totalPages, p)));
  return (
    <div className="flex items-center justify-between gap-2 pt-2" data-testid={testid}>
      <div className="text-xs text-muted-foreground">
        Página <strong>{page}</strong> de <strong>{totalPages}</strong> · {total} {label}{total === 1 ? "" : "s"}
      </div>
      <div className="flex items-center gap-1">
        <Button size="sm" variant="outline" className="h-7 px-2"
          onClick={() => goto(page - 1)} disabled={page <= 1}
          data-testid={`${testid}-prev`} aria-label="Página anterior">
          <ChevronLeft className="w-3.5 h-3.5" />
        </Button>
        <Button size="sm" variant="outline" className="h-7 px-2"
          onClick={() => goto(page + 1)} disabled={page >= totalPages}
          data-testid={`${testid}-next`} aria-label="Próxima página">
          <ChevronRight className="w-3.5 h-3.5" />
        </Button>
      </div>
    </div>
  );
}
